import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="creator--subscription-price-form"
export default class extends Controller {
  static targets = ["confirmationCheckbox", "submitButton"]

  connect() {
    this.toggleSubmitButton()
  }

  toggleSubmitButton() {
    this.submitButtonTarget.disabled = !this.confirmationCheckboxTarget.checked
  }

  submit() {
    if (this.confirmationCheckboxTarget.checked) {
      this.submitButtonTarget.click()
    }
  }
}
